// admin/AdminLayout.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AdminHome from './admin/home';
import Admin from './admin';
import NavheadDash from './admin/components/DashboardHeader';
import Products from './admin/products';
import Login from './admin/login';
import Orders from './admin/orders';
import Singleorders from './admin/Singleorders';
import Completeorder from './admin/Completeorders';
import Updateproducts from './admin/pages/Updateproducts';
import Pendinorders from './admin/Pendinorders';
import Cakeproduct from './admin/pages/Cakeproduct';
import Contact from './admin/Contact';
import Special from './admin/Special';

const AdminLayout = () => {
  return (
    <div>
      {/* Add admin layout components (sidebar, header, etc.) here */}
      <NavheadDash />
      <Routes>
        <Route path="/home" element={<AdminHome />} />
        <Route path="/products" element={<Products />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/special" element={<Special />} />
        {/* <Route path="/index" element={<Login />} /> */}
        <Route path="/orders" element={<Orders />} />
        <Route path="/complete" element={<Completeorder />} />
        <Route path="/pending" element={<Pendinorders />} />
        <Route path="/cake" element={<Cakeproduct />} />
        <Route path="/update/:id" element={<Updateproducts />} />
        <Route path="/single/:id" element={<Singleorders />} />
        <Route path="/" element={<Admin />} />
        {/* Add more admin routes as needed */}
      </Routes>
    </div>
  );
};

export default AdminLayout;
